import React from 'react';
import { Translation } from 'react-i18next';
import { Typography, Progress, Button, Tag } from 'antd';
import { withRouter } from 'react-router-dom';

import useWindowDimensions from '../../../../../lib/WindowDimensions';
import Logger from '../../../../../lib/Logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { pathTo } from '../../../Routes';
import classNames from 'classnames';

const { Title, Text } = Typography;

const LearningModuleStepsList = ({
  stepsComplete,
  percentage,
  activeId,
  moduleId,
  list,
  total,
  moduleStepIdActive,
  ...props
}) => {
  const { width } = useWindowDimensions();
  const isSmall = width <= 576;

  const viewModuleLearningStep = (moduleStepId) => {
    props.history.push(
      pathTo('LearningModuleStepView', { id: activeId, moduleId, moduleStepId })
    );
  };

  const goToStep = (moduleStepIdActive) => {
    props.history.push(
      pathTo('LearningModuleStepView', {
        id: activeId,
        moduleId,
        moduleStepId: moduleStepIdActive,
      })
    );
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div
            className={classNames('ant-steps-item', {
              'learning-module-learning-steps-list-header': !isSmall,
              'learning-module-learning-steps-list-header-small': isSmall,
            })}
          >
            <Title level={4} className='learning-module-learning-steps-title'>
              {t('learning_total_steps_complete', {
                totalComplete: stepsComplete,
                total,
              })}
            </Title>
            <Progress
              strokeColor={percentage === 100 ? '#52c41a' : '#437fda'}
              percent={percentage}
              format={(percent) =>
                `${percent}% ${t('learning_module_complete')}`
              }
            />
          </div>

          <div className='ant-steps ant-steps-vertical learning-module-learning-steps-list'>
            {list.map((x) => (
              <div
                className={classNames('ant-steps-item', {
                  'ant-steps-item-process': x.state === 2,
                  'ant-steps-item-active': x.state === 2,
                  'ant-steps-item-wait': x.state === 1 || x.state === 4,
                  'ant-steps-item-finish': x.state === 3,
                })}
              >
                <div className='ant-steps-item-container'>
                  <div className='ant-steps-item-tail'></div>
                  <div className='ant-steps-item-icon'>
                    {x.state === 3 ? (
                      <span class='ant-steps-icon'>
                        <span
                          role='img'
                          aria-label='check'
                          class='anticon anticon-check ant-steps-finish-icon'
                        >
                          <svg
                            viewBox='64 64 896 896'
                            focusable='false'
                            data-icon='check'
                            width='1em'
                            height='1em'
                            fill='currentColor'
                            aria-hidden='true'
                          >
                            <path d='M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'></path>
                          </svg>
                        </span>
                      </span>
                    ) : (
                      <span className='ant-steps-icon'>{x.order}</span>
                    )}
                  </div>
                  <div className='ant-steps-item-content'>
                    <div className='ant-steps-item-title'>
                      <div className='learning-module-learning-step-title'>
                        <Text>{x.title}</Text>
                        <FontAwesomeIcon
                          style={{ color: '#4e77b8', cursor: 'pointer' }}
                          icon={faArrowRight}
                          onClick={() => viewModuleLearningStep(x.id)}
                        />
                      </div>
                    </div>
                    <div className='ant-steps-item-description'>
                      <div className='learning-module-learning-step-description'>
                        <span className='ant-typography ant-typography-secondary'>
                          {x.state === 4 || x.state === 1 ? (
                            t(`learning_module_learning_step_state_${x.state}`)
                          ) : (
                            <Tag
                              color={classNames({
                                '#22c55e': x.state === 3,
                                '#f28f00': x.state === 2,
                              })}
                            >
                              {t(
                                `learning_module_learning_step_state_${x.state}`
                              )}
                            </Tag>
                          )}
                        </span>
                        <span className='ant-typography ant-typography-secondary'>
                          {x.description}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Button
            type='primary'
            size='large'
            className='learning-module-learning-steps-list-button'
            onClick={() => goToStep(moduleStepIdActive)}
          >
            {t('learning_module_learning_steps_button')}
          </Button>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleStepsList);

Logger.log('silly', `LearningModuleStepsList loaded.`);
